import { convertErrorsToHtmlString, type DjangoRestFrameworkErrorType } from "@/utils/DjangoError";
import { strippedHtml } from "@/utils/Formatters";
import { scrollToFirstError } from "@/utils/FormUtils";
import { isAxiosError } from "axios";
import { defineStore } from "pinia";
import { reactive, ref } from "vue";

export const useSnackStore = defineStore("snack", () => {
  const defaultTimeout = 3000;
  const show = ref(false);
  const snack = reactive<IShowSnack>({
    message: "",
    timeout: defaultTimeout,
    color: "",
  });

  function calculateTimeout(message: string): number {
    const plainTextMessage = strippedHtml(message);
    const readingSpeed = 10; // Approximate number of characters per second
    const estimatedTime = (plainTextMessage.length / readingSpeed) * 1000;
    return Math.max(defaultTimeout, estimatedTime);
  }

  function showSnack(showSnack: IShowSnack) {
    snack.message = showSnack.message || "";
    snack.timeout = showSnack.timeout || calculateTimeout(snack.message);
    snack.color = showSnack.color || "notice";
    show.value = true;

    if (showSnack.color === "error") {
      scrollToFirstError();
    }
  }

  function showError(message: any) {
    console.error(message);
    if (isAxiosError<DjangoRestFrameworkErrorType>(message) && message.response?.data && message.response?.status != 500) {
      message = convertErrorsToHtmlString(message.response?.data);
    } else {
      message = String(message);
    }

    showSnack({ message: message, color: "error" });
  }

  function showSuccess(message: unknown) {
    showSnack({ message: String(message), color: "success" });
  }

  return { show, snack, showSnack, showError, showSuccess };
});

export interface IShowSnack {
  message: string;
  timeout?: number;
  color: string;
}
